import {ADD_QUESTION_RESPONSE, UPDATE_QUESTION_RESPONSE, SET_QUESTION_RESPONSES, UNSET_QUESTION_RESPONSE} from "./actionTypes";

export function setQuestionResponses(questionResponses) {
  return {
    type: SET_QUESTION_RESPONSES,
    questionResponses
  }
}

export function addQuestionResponse(questionResponse) {
  return {
    type: ADD_QUESTION_RESPONSE,
    questionResponse
  }
}

export function updateQuestionResponse(questionResponse) {
  return {
    type: UPDATE_QUESTION_RESPONSE,
    questionResponse
  }
}

export function unsetQuestionResponse(question) {
  return dispatch => {
    dispatch({
      type: UNSET_QUESTION_RESPONSE,
      question
    });
  };
}